var React = require('react');

function Comment01 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.986.25a1.944,1.944,0,0,1,1.429.586A1.888,1.888,0,0,1,20,2.217V14.208a2,2,0,0,1-2.014,2.014H3.981L0,20.2V2.217A1.888,1.888,0,0,1,.586.836,1.946,1.946,0,0,1,2.014.25ZM6.979,9.243V7.229H5.012V9.243Zm4.028,0V7.229H8.994V9.243Zm3.981,0V7.229H12.975V9.243Z","transform":"translate(0 -0.25)","fill":"currentColor"}));
}

Comment01.defaultProps = {"width":"20","height":"19.953","viewBox":"0 0 20 19.953"};

module.exports = Comment01;

Comment01.default = Comment01;
